import React from 'react';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import Inline from '@atlaskit/primitives/inline';
import { Y500 } from '@atlaskit/theme/colors';
/**
 * __Footer items__
 *
 * The footer items in the comment. Usually reserved for error messages.
 *
 * @internal
 */
var Footer = function Footer(_ref) {
  var _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    _ref$errorActions = _ref.errorActions,
    errorActions = _ref$errorActions === void 0 ? [] : _ref$errorActions,
    errorIconLabel = _ref.errorIconLabel,
    isError = _ref.isError,
    isSaving = _ref.isSaving,
    testId = _ref.testId;
  if (isSaving || !(actions.length || errorActions.length)) {
    return null;
  }
  var items = isError ? errorActions : actions;
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    shouldWrap: true,
    testId: testId,
    space: "space.100",
    separator: "\xB7"
  }, isError && /*#__PURE__*/React.createElement(WarningIcon, {
    primaryColor: "var(--ds-text-warning, ".concat(Y500, ")"),
    label: errorIconLabel ? errorIconLabel : ''
  }), items.map(function (item, key) {
    return Object.assign({}, item, {
      key: key
    });
  }));
};
Footer.displayName = 'CommentFooter';
export default Footer;